import { Box, alpha, useTheme } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ExpandedArrowBox = ({ expanded }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 32,
        height: 32,
        borderRadius: 2,
        background: alpha(theme.palette.primary.main, 0.08),
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          background: alpha(theme.palette.primary.main, 0.12),
          transform: "scale(1.1)",
        },
      }}
    >
      {expanded ? (
        <KeyboardArrowUpIcon color='primary' sx={{ fontSize: 20 }} />
      ) : (
        <KeyboardArrowDownIcon color='primary' sx={{ fontSize: 20 }} />
      )}
    </Box>
  );
};

export default ExpandedArrowBox;
